import avatar from "assets/images/avatar.jpg";
import classNames from "classnames";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Avatar from "./Avatar";
import "./style.scss";

const Cover = ({ src }) => {
  const { i18n } = useTranslation();
  const [background, setBackground] = useState({});
  useEffect(() => {
    const img = document.createElement("img");
    img.src = src;
    img.onload = () => setBackground({ backgroundImage: `url(${src})` });
  }, [src]);
  return (
    <div className="cover" style={background}>
      <div className="container text-center">
        <div className="switch-language-container btn-group">
          <button
            className={classNames(
              "btn",
              i18n.language.startsWith("zh") && "btn-primary"
            )}
            onClick={() => i18n.changeLanguage("zh")}
          >
            中文
          </button>
          <button
            className={classNames(
              "btn",
              i18n.language.startsWith("en") && "btn-primary"
            )}
            onClick={() => i18n.changeLanguage("en")}
          >
            English
          </button>
        </div>
        <div className="cover-wrapper">
          <Avatar src={avatar} />
          <br />
          <div className="text-center name">
            <h3>Yang Lin</h3>
            <h6>@Taipei, Taiwan</h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cover;
